import type { ComponentPropsWithoutRef } from "react";
import { twMerge } from "tailwind-merge";

export const Anchor = ({
  className,
  rel,
  target,
  ...props
}: ComponentPropsWithoutRef<"a">) => (
  <a
    {...props}
    target={target}
    rel={
      target === "_blank"
        ? [rel, "noopener", "noreferrer"].filter(Boolean).join(" ")
        : rel
    }
    className={twMerge("cursor-pointer text-blue-600 underline", className)}
  />
);
